export default function HandRankBadge({ rank, hide = false }) {
  if (!rank || hide) return null;

  return (
    <div className="hand-rank-badge">
      <span className="hand-icon">✋</span>
      <span>{rank}</span>
    </div>
  );
}